import { Button, Card } from "antd";
import PropTypes from "prop-types";
import React from "react";

const { Meta } = Card;

const Tool = props => {
  const { title, image, description, link } = props;

  return (
    <React.Fragment>
      <a href={link} target="_blank">
        <Card hoverable cover={<img className="tool-image" alt={title} src={image} />}>
          <Meta title={title} description={description} />
        </Card>
      </a>
    </React.Fragment>
  );
};

Tool.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired
};

export default Tool;



// WEBPACK FOOTER //
// ./src/components/Tools/Tool.js